import { lazy } from 'react';

const PromptLabPage = lazy(() =>
  import('./prompt-lab/page.js').then((module) => ({ default: module.PromptLabPage })),
);

const HighYieldExplanation = lazy(() =>
  import('./high-yield/page.js').then((module) => ({ default: module.HighYieldInput })),
);

export { HighYieldExplanation, PromptLabPage };
